import { render, staticRenderFns } from "./ConnectThePuzzles.vue?vue&type=template&id=2c8776c6&lang=pug&"
import script from "./ConnectThePuzzles.vue?vue&type=script&lang=js&"
export * from "./ConnectThePuzzles.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports